import { useCallback } from 'react';
import { Button, ButtonVariants } from '../../../Button';
import { Stack } from '../../../Core';
import { Text } from '../../../Text';
import { useMobileModal } from '../../MobileModalSheet';
import { MobileModalSheetActionsContainer } from '../../styles';
import { OverflowModalWrapper } from '../OverflowModal/styles';
import type { TabBarItem } from '../types';

interface DeleteTabConfirmModalProps {
  item: TabBarItem;
  onDeleteItem?: (item: TabBarItem) => void;
  onConfirmDelete?: () => void;
}

export function DeleteTabConfirmModal({ item, onDeleteItem, onConfirmDelete }: DeleteTabConfirmModalProps) {
  const { closeModal, popModal } = useMobileModal();

  const handleDelete = useCallback(() => {
    onDeleteItem?.(item);
    if (onConfirmDelete != null) {
      onConfirmDelete();
      return;
    }
    closeModal();
  }, [closeModal, item, onConfirmDelete, onDeleteItem]);

  return (
    <OverflowModalWrapper>
      <Stack gap="spacing12">
        <Text color="colorTextImportant">
          {item.removeConfirmationText ?? `You are about to remove the "${item.label ?? 'this'}" tab.`}
        </Text>
        <Text color="colorTextImportant">Would you like to proceed?</Text>
      </Stack>
      <MobileModalSheetActionsContainer mt="auto">
        <Button flex={1} pill onClick={popModal} data-testid="mobile-sub-tab-delete-cancel-button">
          Cancel
        </Button>
        <Button
          flex={1}
          pill
          variant={ButtonVariants.Negative}
          onClick={handleDelete}
          data-testid="mobile-sub-tab-delete-confirm-button"
        >
          Remove tab
        </Button>
      </MobileModalSheetActionsContainer>
    </OverflowModalWrapper>
  );
}

export function getRemoveTabTitle(item: TabBarItem) {
  return `Remove "${item.label ?? 'this'}" tab`;
}
